export default "__VITE_ASSET__BwQo6NyV__"